<div class="container-fluid">
    <div class="row pl--1rem8 d-flex align-items-center">
        <div class="col-md-10 page-heading page-header">
            <h2>Manage LCA</h2>
            <p>Manage existing LCAs or create new LCA</p>
        </div>
        <div *ngIf="!isI9Admin" class="col-md-2 pr-0">
            <button  type="button" (click)="createNew()" class="btn btn-primary mt-0 float-right btn-add" label="Create LCA" 
                ><i class="fa fa-plus-circle" aria-hidden="true"></i>&nbsp;Create LCA</button>
        </div>
    </div>

    <!-- <mat-divider class="pb-15"></mat-divider> -->

    <div class="row tab-container pt-4 pb-2">
        <div class="col">
            <mat-tab-group (selectedTabChange)="onTabChanged($event)">
                <mat-tab label="All LCAs {{totalRecordCount? '(' + totalRecordCount + ')' :null}}"> 
                    <div class="row bg-white p-0 pt-4 pb-4">
                        <div class="col-12 p-0 pt-2 pb-2">
                            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="dataSource" matSort>
                                <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
                                    <ng-container *ngIf="['Notes','Action'].includes(column.header)">
                                        <th mat-header-cell *matHeaderCellDef> {{column.header}} </th>
                                    </ng-container>
                                    <ng-container *ngIf="!['Notes','Action'].includes(column.header)">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                                    </ng-container>
                                    <td mat-cell *matCellDef="let row" [ngClass]="[column.columnDef == 'comment' ? 'mat-cell-wrap-text1' : '']">
                                        <span *ngIf="column.columnDef =='status'">
                                            <span [ngClass]="{'live-status': row.status?.name == 'Live', 'take-down-status': row.status?.name == 'Take Down'}">
                                                <span *ngIf="row.status?.name == 'Take Down'; else postedLcaStatus">Taken Down</span>
                                                <ng-template #postedLcaStatus>
                                                    <span>{{row.status?.name}}</span>
                                                </ng-template>
                                            </span>
                                        </span>
                                        <span *ngIf="column.columnDef =='visaType'">
                                            {{row.visaType?.code}}
                                        </span>
                                        <span *ngIf="column.columnDef =='employmentStartDate' || column.columnDef =='employmentEndDate'">
                                            {{row[column.columnDef] | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef !=='visaType' && column.columnDef !=='status' && column.columnDef !=='employmentStartDate' && column.columnDef !=='employmentEndDate' && column.columnType !=='icon'">
                                            {{row[column.columnDef]}}
                                        </span>
                
                                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                                            <div class="row" >
                                                <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                                                    <mat-icon>settings</mat-icon>
                                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                                </mat-icon>
                                                <mat-menu #menu="matMenu">
                                                    <button mat-menu-item matTooltip="View" (click)="handleView(row)">View</button>   
                                                    <button *ngIf="['LCAEXTFIL','LCAEFIL'].includes(row.status?.code)" mat-menu-item matTooltip="Edit" (click)="handleEdit(row, false)">Edit</button>
                                                    <button *ngIf="row.status?.code == 'LCAEFIL' || row.status?.code == 'LCAEXTFIL'" mat-menu-item matTooltip="Update Decision" (click)="updateLcaDecision(row)">Update Decision</button>
                                                    <button *ngIf="row.status?.code == 'LCAASSIGN'" matTooltip="Post LCA" mat-menu-item (click)="openPostLcaModal(row)">Post LCA</button>           
                                                    <button *ngIf="row.status?.code == 'LCAASSIGN' || row.status?.code == 'LCACERT'" matTooltip="Post LCA" mat-menu-item (click)="openWithdrawLcaModal(row)">Withdraw LCA</button>
                                                    <button mat-menu-item matTooltip="Duplicate LCA" (click)="handleEdit(row, true)">Duplicate LCA</button>                                         
                                                    <button mat-menu-item matTooltip="Delete" (click)="handleDelete(row)">Delete</button>
                                                </mat-menu>
                                            </div>
                                        </span>
                
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                </tr>
                            </table>
                
                            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                            <mat-paginator [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [length] = "totalRecordCount"
                            (page)="paginationEvent($event)"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Posted LCAs {{totalPostedLcaRecordCount? '(' + totalPostedLcaRecordCount + ')' :null}}">  
                    <div class="row bg-white p-0 pt-4 pb-4">
                        <div class="col-12 p-0 pt-2 pb-2">
                            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="postedLcaDataSource" matSort>
                                <ng-container *ngFor="let column of postedLcaColumns" [matColumnDef]="column.columnDef">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                                    <td mat-cell *matCellDef="let row" [ngClass]="[column.columnDef == 'comment' ? 'mat-cell-wrap-text1' : '']">
                                        <span *ngIf="column.columnDef =='status'">
                                            <span [ngClass]="{'live-status': row.status?.name == 'Live', 'take-down-status': row.status?.name == 'Take Down'}">
                                                <span *ngIf="row.status?.name == 'Take Down'; else postedLcaStatus">Taken Down</span>
                                                <ng-template #postedLcaStatus>
                                                    <span>{{row.status?.name}}</span>
                                                </ng-template>
                                            </span>
                                        </span>
                                        <span *ngIf="column.columnDef =='visaType'">
                                            {{row.visaType?.code}}
                                        </span>
                                        <span *ngIf="column.columnDef =='postedDate'">
                                            {{row[column.columnDef] | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef !=='visaType' && column.columnDef !=='status' && column.columnDef !=='employmentStartDate' && column.columnDef !== 'postedDate' && column.columnDef !=='employmentEndDate' && column.columnType !=='icon'">
                                            {{row[column.columnDef]}}
                                        </span>
                
                                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                                            <div class="row" >
                                                <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                                                    <mat-icon>settings</mat-icon>
                                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                                </mat-icon>
                                                <mat-menu #menu="matMenu">
                                                    <button mat-menu-item matTooltip="View" (click)="viewPostedLCA(row)">View Posted LCA</button>
                                                    <button *ngIf="row.status?.name == 'Live'" mat-menu-item matTooltip="Edit" (click)="editPostedLCA(row)">Edit</button>
                                                    <button *ngIf="row.status?.name == 'Live'" mat-menu-item matTooltip="Take Down" (click)="openActionAlertModal(row, 'take down')">Take Down</button>
                                                    <button mat-menu-item matTooltip="Archive" (click)="openActionAlertModal(row, 'archive')">Archive</button>
                                                </mat-menu>
                                            </div>
                                        </span>
                
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="postedLcaDisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: postedLcaDisplayedColumns;">
                                </tr>
                            </table>
                
                            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                            <mat-paginator [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [length] = "totalPostedLcaRecordCount"
                            (page)="paginationEvent($event)"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Archived LCAs {{totalArchivedLcaRecordCount? '(' + totalArchivedLcaRecordCount + ')' :null}}">
                    <div class="row bg-white p-0 pt-4 pb-4">
                        <div class="col-12 p-0 pt-2 pb-2">
                            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="archivedLcaDataSource" matSort>
                                <ng-container *ngFor="let column of archivedLcaColumns" [matColumnDef]="column.columnDef">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                                    <td mat-cell *matCellDef="let row" [ngClass]="[column.columnDef == 'comment' ? 'mat-cell-wrap-text1' : '']">
                                        <span *ngIf="column.columnDef =='status'">
                                            {{row.status?.name}}
                                        </span>
                                        <span *ngIf="column.columnDef =='visaType'">
                                            {{row.visaType?.code}}
                                        </span>
                                        <span *ngIf="column.columnDef =='archivedDate'">
                                            {{row[column.columnDef] | ImgDateFormat}}
                                        </span>
                                        <span *ngIf="column.columnDef !=='visaType' && column.columnDef !=='status' && column.columnDef !=='employmentStartDate' && column.columnDef !=='employmentEndDate' && column.columnDef !='archivedDate' && column.columnType !=='icon'">
                                            {{row[column.columnDef]}}
                                        </span>
                
                                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                                            <div class="row" >
                                                <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                                                    <mat-icon>settings</mat-icon>
                                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                                </mat-icon>
                                                <mat-menu #menu="matMenu">
                                                    <button mat-menu-item matTooltip="Restore" (click)="restoreArchivedLCA(row)">Restore</button>
                                                    <button mat-menu-item matTooltip="Delete" (click)="openActionAlertModal(row, 'delete')">Delete</button>
                                                </mat-menu>
                                            </div>
                                        </span>
                
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="archivedLcaDisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: archivedLcaDisplayedColumns;">
                                </tr>
                            </table>
                
                            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                            <mat-paginator [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [length] = "totalArchivedLcaRecordCount"
                            (page)="paginationEvent($event)"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>


                <!-- This below Audit log tab will go as separate release as an enhancement -->
                <!-- LCA AUDIT LOG -->


                <!-- <mat-tab label="LCA Audit Logs {{totalAuditRecordCount? '(' + totalAuditRecordCount + ')' :null}}">
                    <div class="row bg-white p-0 pt-4 pb-4">
                        <div class="col-12 p-0 pt-2 pb-2">
                            <table class="im-card-no-border-table table im-card-table-noborder-spacing table-header_uppercase table-striped-simple" mat-table [dataSource]="auditLcaDataSource" matSort>
                                <ng-container *ngFor="let column of auditLcaColumns" [matColumnDef]="column.columnDef">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                                    <td mat-cell *matCellDef="let _data" [ngClass]="[column.columnDef == 'comment' ? 'mat-cell-wrap-text1' : '']">
                                        <span>
                                            {{_data[column.columnDef]}}
                                        </span>
                                       
                
                                        <span class="column.customClass" *ngIf="column.columnType=='icon'">
                                            <div class="row" >
                                                <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                                                    <mat-icon>settings</mat-icon>
                                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                                </mat-icon>
                                                <mat-menu #menu="matMenu">
                                                    <button mat-menu-item matTooltip="Restore">View</button>
                                                    <button mat-menu-item matTooltip="Delete" >Delete</button>
                                                </mat-menu>
                                            </div>
                                        </span>
                
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="auditLcaDisplayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: auditLcaDisplayedColumns;">
                                </tr>
                            </table>
                
                            <mat-paginator [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [length] = "totalArchivedLcaRecordCount"
                            (page)="paginationEvent($event)"></mat-paginator>
                        </div>
                    </div>
                </mat-tab> -->
                <!-- LCA AUDIT LOG -->
            </mat-tab-group>
            <div class="lca-table-filter" *ngIf="showFilterButton">
              <div class="col filter-tab">
                <button class="btn-filter" (click)="openFilterBox()">Filter <i class="pi pi-filter"></i></button>
                <div class="filter-box" *ngIf="filterBoxVisible">
                    <h6>Filter By:</h6>
                    <form [formGroup]="filterForm">
                        <div class="row">
                            <div class="col-12 p-0">
                                <div class="form-group">
                                    <label for="caseId" class="mb-0">Case ID</label>
                                    <input type="text" formControlName="caseId" class="form-control m-0">
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-12 p-0">
                                <div class="form-group">
                                    <label for="status" class="mb-0">Status</label>
                                    <select formControlName="status" class="form-control m-0">
                                    <option value="Select Status">Select Status</option>
                                    <option *ngFor="let option of statusOptions" [value]="option">{{ option }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="col-6 pl-0">
                                <div class="form-group">
                                    <label for="startDate" class="mb-0">Start Date</label>
                                    <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                                        <input    
                                        matInput
                                        name="lcaStartDate"
                                        formControlName="startDate"
                                        [matDatepicker]="picker1" placeholder="MM/DD/YYYY">
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-6 pr-0">
                                <div class="form-group">
                                    <label for="endDate" class="mb-0">End Date</label>
                                    <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                                        <input    
                                        matInput
                                        name="lcaEndDate"
                                        formControlName="endDate"
                                        [matDatepicker]="picker2" placeholder="MM/DD/YYYY">
                                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="mt-3">
                        <button class="btn btn-primary mr-2" (click)="applyAdvanceFilter()">Apply</button>
                    </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</div>
